module.exports = __webpack_public_path__ + "media/images/athletes/1673-39252954a517ca3834ae0ac8dca1670e.png";